var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitySurface3DChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "surface_3d_chart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.149 17.716l-1.307-5.543c-0.117-0.498-0.559-0.854-1.070-0.864-0.006 0-0.014 0-0.021 0-0.502 0-0.945 0.335-1.080 0.82l-0.426 1.527-1.307-7.394c-0.094-0.531-0.553-0.921-1.094-0.926-0.525-0.003-1.008 0.375-1.109 0.905l-1.754 8.954-1.248-3.846c-0.16-0.491-0.613-0.82-1.15-0.772-0.514 0.038-0.938 0.424-1.021 0.934l-0.997 5.967-9.564 3.188 16 5.333 16-5.333-8.851-2.95zM9.191 19.711l-0.302 1.81-2.564-0.855 2.866-0.955zM11.042 22.239l0.974-5.832 1.168 3.597c0.156 0.486 0.582 0.828 1.135 0.773 0.51-0.031 0.934-0.402 1.031-0.904l1.428-7.291 1.119 6.328c0.090 0.516 0.527 0.898 1.049 0.924 0.561 0.066 0.994-0.314 1.135-0.818l0.58-2.082 0.609 2.59c0.143 0.6 0.727 0.969 1.35 0.834 0.292-0.069 0.527-0.25 0.679-0.483l2.378 0.792-9.676 3.225-4.958-1.653z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitySurface3DChart);
export default __webpack_public_path__ + "static/media/unity_surface_3d_chart.9824704ea14213ec46392d804449e20a.svg";
export { ForwardRef as ReactComponent };